module.exports = __webpack_public_path__ + "img/doorbell-robin.594b451a.png";